//i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './ar/index';
import br from './br/index';
import cn from './cn/index';
import en from './en/index';
import id from './id/index';
import inn from './in/index';
import kr from './kr/index';
import jp from './jp/index';
import tw from './tw/index';
import it from './it/index';
import fr from './fr/index';
import ru from './ru/index';
import es from './es/index';
import de from './de/index';
import tr from './tk/index';
import nl from './nl/index';

import Utils from '../utils/utils';
const resources = {
  ar,
  cn,
  en,
  id,
  inn,
  kr,
  br,
  jp,
  tw,
  it,
  fr,
  ru,
  es,
  de,
  nl,
  tr,
};

// //测试地址
// const rootElement = document.getElementById("hitpaw-online-root");
// let urlParams = new URLSearchParams(window.location.search);
// if (urlParams.has("lang")) {
//   rootElement.setAttribute("lang", urlParams.get("lang"));
// }
let lang = Utils.getLanguage();
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: lang === 'in' ? 'inn' : lang,
    // lng: "kr",
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
